import React from 'react';
import { loadFromLocalStorage } from '../../Common/Validation/LocalStorage';
import DataGrid from '../../Component/DataGrid/DataGrid';
import DataTable, { TableColumn } from 'react-data-table-component';
import { ICompliance, RequestType } from '../TransactionLogs/Interface';
//import { Box, Button, TextField, Typography, buttonBaseClasses } from '@mui/material';
import ComplianceForm, { Status } from '../../Component/ComplianceForm';
import TransactionService from '../../Services/TransactionService';
import moment from 'moment';
//import { ShowAlert } from '../../Component/ShowAlert';
// import { Link } from "react-router-dom";
import { SyncContext, SyncContextType } from '../../Contexts/BatchSyncContext';
import UserAndPermissionService from '../../Services/UserAndPermissionService';
import { ComplianceLogsPermissions } from '../../Component/Permissions/PermissionsInterface.';

interface ComplianceProps {}
interface ComplianceState {
    currentPage: number,
    accessToken: string,
    complianceData: ICompliance[],
    currentRowsPerPage: number,
    totalRows: number,
    searchText: string,
    adminCommandTF: string,
    complianceLogs: ComplianceLogsPermissions

}

class Compliance extends React.Component<ComplianceProps, ComplianceState> {
    static contextType = SyncContext;
    public title = "Compliance Logs";
    context!: SyncContextType;
    private tableColumns: TableColumn<ICompliance>[] = [
        {
            name: 'Request Id',
            selector: row => row.ticketNumber,
            sortable: false,
            id: "ticketNumber",
            width: "150px",
            wrap: true

        },
        {
            name: 'Transaction Id',
            selector: row => row.transactionId ? row.transactionId : '',
            sortable: true,
            id: "transactionId",
            // cell: row => <Link to={"/transactionlogs?id=" + row.transactionId} >{row.transactionId}</Link>
            cell: (row) => {
                const { complianceLogs } = this.state

                return complianceLogs.isTransactionNavigationAllowed ? (
                    <a href={`/transactionlogs?id=${row.transactionId}`}>
                        {row.transactionId}
                    </a>
                ) : (
                    <span>{row.transactionId}</span>
                );
            },
            width: "120px",
            wrap: true
        },
        {
            name: 'Request Type',
            selector: row => row.ticketType,
            sortable: true,
            id: "ticketType",
        },
        {
            name: 'Requester',
            selector: row => row.customer,
            sortable: true,
            id: "customer",
            minWidth: "250px",
            wrap: true,
        },
        {
            name: 'Description',
            selector: row => row.description,
            sortable: false,
            id: "description",
            minWidth: "250px",
            maxWidth: "400px",
            wrap: true
        },
        {
            name: 'Status',
            selector: row => row.ticketStatus,
            sortable: true,
            id: "ticketStatus",
            minWidth: "140px",
            wrap: true
        },
        {
            name: 'Request Date',
            selector: row => moment(row.created_utc).format('MM-DD-YYYY hh:mm A'),
            sortable: true,
            id: "created_utc",
            minWidth: "170px",
            center: true
        },
        {
            name: 'Completed Date',
            selector: row => row.resolved_utc ? moment(row.resolved_utc).format('MM-DD-YYYY hh:mm A') : "-",
            sortable: true,
            id: "resolved_utc",
            minWidth: "170px",
            center: true
        },
        {
            name: 'Zendesk Id',
            selector: row => row.zendeskId,
            sortable: true,
            id: "zendeskId",
            cell: (row) => {
                const { complianceLogs } = this.state

                return complianceLogs.isZendeskNavigationAllowed ? (
                    <a href={row.zendeskUrl} target="_blank" rel="noopener noreferrer">
                        {row.zendeskId}
                    </a>
                ) : (
                    <span>{row.zendeskId}</span>
                );
            },
            center: true,
            minWidth: '110px'
        },
    ]

    adminComment = "";
    ticketStatus: Status | undefined;

    constructor(props_: ComplianceProps) {
        super(props_);

        this.state = {
            accessToken: "",
            complianceData: [],
            currentRowsPerPage: 10,
            currentPage: 1,
            totalRows: 100,
            searchText: "",
            adminCommandTF: "",
            complianceLogs: {
                isVisible: true,
                isZendeskNavigationAllowed: true,
                isTransactionNavigationAllowed: true,
            },
        }
    }

    async componentDidMount() {
        try {
            const accessToken_ = await loadFromLocalStorage('accessToken');
            const profile_ = await loadFromLocalStorage('profile');

            if (!accessToken_ || !profile_) {
                localStorage.clear();
                window.location.href = '/';
                return;
            }

            const accessToken = accessToken_.toString();
            const userProfile = typeof profile_ === 'string' ? JSON.parse(profile_) : profile_;

            this.setState({ accessToken }, async () => {
                try {
                    if (userProfile?.roleId) {
                        const permissionResponseRaw = await UserAndPermissionService.getPermissions(accessToken, userProfile?.roleId);
                        const permissionResponse = await permissionResponseRaw.json();

                        if (!permissionResponse?.permissions?.complianceLogs?.isVisible) {
                            console.warn("Permission denied, logging out...");
                            localStorage.clear();
                            window.location.href = '/';
                            return;
                        }

                        const permissions = permissionResponse.permissions

                        this.context.dispatch({
                            type: "SET_PERMISSION", payload: {
                                permissions
                            },
                        });

                        const complianceLogs = permissionResponse.permissions.complianceLogs

                        this.setState({ complianceLogs }, () => {
                            this.getCompliance();
                        });

                    } else {
                        this.getCompliance();
                    }
                } catch (error) {
                    console.error("Error fetching permissions:", error);
                }
            });
        } catch (error) {
            console.error("Error in componentDidMount:", error);
            localStorage.clear();
            window.location.href = '/';
        }
    }
    private getCompliance() {
        let pageIndex: number = (this.state.currentPage - 1);
        let pagination: any = {
            "pageNumber": (pageIndex * this.state.currentRowsPerPage),
            "recordPerPage": this.state.currentRowsPerPage
        }

        if (this.state.searchText) {
            pagination["searchText"] = this.state.searchText
        }

        TransactionService.getCompliance(this.state.accessToken, pagination).then(tr => {
            if (tr.ok) {
                tr.json().then(resp => {
                    this.setState({
                        complianceData: resp.complianceList,
                        totalRows: resp.pageCount
                    }, () => {

                    })
                });
            }
        });
    }


    // handleCommandSubmit = (command: string) => {
    //     console.log('Command submitted:', command);
    //     // Add your logic to handle the command here
    // }


    // handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     this.setState({ adminCommandTF: event.target.value });
    // };

    // handleFormSubmit = (formData: any) => {
    //     console.log('Form submitted:', formData);
    //     const statusArray = Object.values(Status);
    //     const indexOfStatus = statusArray.indexOf(formData.status);
    //     if (this.adminComment == formData.command && this.ticketStatus == formData.status) {
    //         ShowAlert("PassportPay", "No Changes to update", 'error')

    //     } else if (formData.command == '' || formData.command == null) {
    //         ShowAlert("PassportPay", "Please enter the admin comment", 'error')
    //     }
    //     else {
    //         console.log("formData.command == ''", formData.command);
    //         let pagination: any = {
    //             "ticketId": formData.ticketNumber,
    //             "ticketStatus": indexOfStatus + 1,
    //             "adminComment": formData.command.trim() ?? ""
    //         }
    //         TransactionService.updateCompliance(this.state.accessToken, pagination).then(tr => {
    //             if (tr.ok) {
    //                 this.getCompliance();
    //                 ShowAlert("PassportPay", "Submitted Successfully", 'success')
    //                 tr.json().then(resp => {
    //                 })
    //             }
    //         })
    //     }



    //     // Add your logic to handle the form data here
    // };

    public render() {
        const { complianceLogs } = this.context.state.permissions;

        return (
            <div className='body-sub-contianer table-container'>
                {/* <h1>Transaction Logs</h1> */}
                <DataGrid
                    title={this.title}
                    search={this.title}
                    onSearch={(searchText_: string) => {
                        this.setState({
                            searchText: searchText_,
                            currentPage: 1
                        }, () => {
                            this.getCompliance();
                        })
                    }}
                    columns={this.tableColumns}
                    data={this.state.complianceData}
                    expandableRows
                    onChangePage={(page: number, totalRows: number) => {
                        console.log(page, totalRows);
                        this.setState({
                            currentPage: page
                        }, () => {
                            this.getCompliance();
                        })
                    }}
                    onChangeRowsPerPage={(currentRowsPerPage_: number, currentPage_: number) => {
                        console.log(currentRowsPerPage_, currentPage_);
                        this.setState({
                            currentRowsPerPage: currentRowsPerPage_,
                            currentPage: currentPage_
                        }, () => {
                            this.getCompliance();
                        })
                    }}
                    pagination
                    exportCsv
                    csvFileName={this.title}
                    paginationTotalRows={this.state.totalRows}
                    expandedComponent={(data_: any) => {
                        console.log("data", data_.data.compliance_details);
                        this.ticketStatus = data_.data.ticketStatus;
                        this.adminComment = data_.data.adminComment;
                        return (
                            <div className='details-container' style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                                <ComplianceForm
                                    //onSubmit={this.handleFormSubmit}
                                    initialData={{
                                        ticketNumber: data_.data.ticketNumber,
                                        subject: data_.data.ticketType,
                                        description: data_.data.description,
                                        command: this.adminComment,
                                        status: this.ticketStatus ?? Status.RequestRegistered,
                                        customerName: data_.data.customer,
                                        customerEmail: data_.data.customerEmail,
                                        customerMobile: data_.data.customerMobile,
                                        zendeskId: data_.data.zendeskId,
                                        zendeskUrl: data_.data.zendeskUrl
                                    }}
                                    complianceLogs={complianceLogs}
                                />
                            </div>
                        )
                    }
                    }
                />

            </div>
        )
    }

}

export default Compliance;